__turbopack_context__.v({
  "Head": "vWpWtW_Head",
  "Link": "vWpWtW_Link",
  "SubHead": "vWpWtW_SubHead",
});
